<template>
  <div class="agreement">
    <div class="content">
      <span>用户使用协议</span>
      <b>感谢您使用创客云商平台</b>
      <p>
        感谢您使用创客云商商城！以下为商城服务协议，您应当阅读并遵守《创客云商商城服务使用协议》（以下简称"本协议"），本协议内容以APP展示/更新内容为准，涉及相关业务规则，请您务必审慎阅读、充分理解，特别是限制或免除责任的相应条款（
        <i>限制或免除责任条款可能以黑体加粗形式提示您注意</i>
        ）。如您需使用本协议下某项服务，则必须提前阅读本协议，您对本服务的登录及进行任何操作行为均视为您已阅读并同意本协议的全部条款。如果您对本协议的任何条款有异议，您可以选择不使用创客云商商城服务（以下简称"本服务"）。当您使用任何功能，均意味着您（即用户）完全接受本协议的全部条款。
        <br />
        <i>一、定义</i>
        <br />
        <i>1、“用户”/“您”：</i>
        指使用本服务的用户，仅限于自然人用户，且仅限用户在阅读并接受本协议的全部条款后方可使用本服务，任何非自然人用户（包括任何具备或不具备法人主体资格的机构）在任何情况下均不得以任何方式使用本服务。
        <br />
        <i>2、“中国大陆地区”：</i>
        指中华人民共和国境内除香港特别行政区、澳门特别行政区以及台湾地区以外的其他地区。 
        <br />
        二、本服务条款的确认和接纳
        <br />
        2.1本服务的所有权和运作权归 西安创客村电子商务有限责任公司
        所有。用户确认本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
        <br />
        2.2用户点击同意本协议，即视为用户确认自己具有享受在线购买及享受服务等相应的权利和行为能力，能够独立承担法律责任。
        <br />
        2.3创客云商商城保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
        <br />
        三、本站服务
        <br />
        西安创客村电子商务有限责任公司
        通过互联网依法为用户提供产品信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。
        <br />
        四、用户信息
        <br />
        4.1用户应本着个人诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且西安创客村电子商务有限责任公司保留终止用户使用创客云商商城各项服务的权利。
        <br />
        4.2用户在本站进行浏览、下单等活动时，涉及用户及企业真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本站将予以严格保密，除非得到用户授权或法律另有规定，本站不会向外界披露用户及企业隐私信息。
        <br />
        4.3用户注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定修改您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站。
        <br />
        4.4用户同意，创客云商商城拥有通过邮件、短信电话等形式，向在本站注册、购物用户、收货人发送订单信息、促销活动等告知信息的权利。
        <br />
        4.5用户若将在本站注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。
        <br />
        4.6用户同意，创客村电子商务有限责任公司有权使用用户的注册信息、用户名、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。
        <br />
        五、用户依法言行义务
        <br />
        本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：
        <br />
        （1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
        <br />
        （2）从中国大陆向境外传输资料信息时必须符合中国有关法规；
        <br />
        （3）不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
        <br />
        （4）不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；
        <br />
        （5）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
        <br />
        （6）不得教唆他人从事本条款所禁止的行为；
        <br />
        （7）不得利用在本站注册的账户进行非法牟利经营活动；
        <br />
        用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。
        <br />
        本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。
        <br />
        若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
        <br />
        六、商品信息
        <br />
        本站上的货物价格、数量、是否有货等商品信息将根据市场行情及销售情况随时发生变动，本站不作特别通知。由于网站货物信息数量庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于网络及电脑终端兼容性等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。
        <br />
        七、下单
        <br />
        7.1您在商城下订单时，请您仔细确认所购货物的品名、价格、数量、材质、规格、所在仓库、企业名称、开票地址等信息。若您提供的信息错误导致交易过程中出现利益损失的，则将不承担相应法律责任及连带责任。
        <br />
        7.2
        由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。
        <br />
        八、提货
        <br />
        8.1您在完成支付且您的提货函审核通过后，即可根据购销合同约定及提货函预留信息进行提货。
        <br />
        8.2因如下情况造成无法提货等，创客村电子商务有限责任公司不承担任何责任：
        <br />
        （1）用户提供的提货信息错误导致的；
        <br />
        （2）情势变更因素导致的；
        <br />
        （3）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。
        <br />
        九、责任限制及不承诺担保
        <br />
        除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、资料、货物（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。
        <br />
        除非另有明确的书面说明, 创客村电子商务有限责任公司不对本站的运营及其包含在本网站上的信息、资料、货物（包括软件）和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
        <br />
        如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，创客村电子商务有限责任公司会合理地尽力协助处理善后事宜。
        <br />
        十、协议更新及用户关注义务
        <br />
        根据国家法律法规变化及网站运营需要，创客村电子商务有限责任公司有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登陆查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受创客村电子商务有限责任公司依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。创客村电子商务有限责任公司建议您在使用本站之前阅读本协议及本站的公告。 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
        <br />
        十一、 法律管辖和适用
        <br />
        11.1本协议的订立、执行和解释及争议的解决均应适用中国大陆地区法律。
        <br />
        <i>
          11.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，您和创客云商商城一致同意交由西安创客村电子商务有限责任公司所在地有管辖权的法院管辖。
        </i>
        <br />
        十二、 其他
        <br />
        12.1创客村电子商务有限责任公司所有者是指在政府部门依法许可或备案的 经营主体。
        <br />
        12.2
        创客村电子商务有限责任公司尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，创客村电子商务有限责任公司将虚心接受并适时修改本协议及本站上的各类规则。
        <br />
        12.3用户对本服务之任何部分或本协议的任何部分之意见及建议可与创客村电子商务有限责任公司联系。
      </p>
    </div>
    <footer class="webView" v-if="webView">
      <button class="btn graybtn" @click="no">不同意</button>
      <button class="btn redbtn" @click="yes">同意</button>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'agreement',
  data() {
    return {
      webView: false
    }
  },
  mounted() {
    if (this.$route.query.pt && this.$route.query.pt == 'app') {
      this.webView = false
    } else {
      this.webView = true
    }
    if (isWeixin()) {
      fenxiang({ path: 'agreement' })
    }
  },
  methods: {
    no() {
      if (this.$route.query.type == 'login') {
        this.$router.replace({
          path: 'login',
          query: {
            ...this.$route.query,
            isagree: 2
          }
        })
      } else if (this.$route.query.type == 'bound') {
        var obj
        if (this.$route.query.token) {
          obj = {
            isagree: 2,
            pt: this.$route.query.pt,
            token: this.$route.query.token
          }
        } else {
          obj = {
            isagree: 2
          }
        }
        obj.router = 'replace'
        this.$router.replace({
          path: 'bound',
          query: obj
        })
      }
    },
    yes() {
      if (this.$route.query.type == 'login') {
        this.$router.push({
          path: 'login',
          query: {
            ...this.$route.query,
            isagree: 1
          }
        })
      } else if (this.$route.query.type == 'bound') {
        var obj
        if (this.$route.query.token) {
          obj = {
            isagree: 1,
            pt: this.$route.query.pt,
            token: this.$route.query.token
          }
        } else {
          obj = {
            isagree: 1
          }
        }
        this.$router.push({
          path: 'bound',
          query: obj
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.agreement {
  background: #fff url(../../assets/images/agreement.png) no-repeat right 0.1rem;
  background-size: 50%;
  .content {
    padding: 0.27rem 0.3rem 0.68rem 0.3rem;
    span {
      display: block;
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 0.33rem;
    }
    b {
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(58, 58, 58, 1);
      line-height: 0.2rem;
      display: block;
      margin-top: 0.28rem;
      margin-bottom: 0.44rem;
    }
    p {
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(58, 58, 58, 1);
      line-height: 0.2rem;
    }
    i {
      font-weight: 700;
      font-style: normal;
    }
  }
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 0.08rem 0px rgba(227, 227, 227, 0.32);
    -o-box-shadow: 0px -1px 0.08rem 0px rgba(227, 227, 227, 0.32);
    -moz-box-shadow: 0px -1px 0.08rem 0px rgba(227, 227, 227, 0.32);
    -ms-box-shadow: 0px -1px 0.08rem 0px rgba(227, 227, 227, 0.32);
    -webkit-box-shadow: 0px -1px 0.08rem 0px rgba(227, 227, 227, 0.32);
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    padding: 0.1rem 0.54rem;
    .btn {
      display: block;
      padding: 0.08rem 0.27rem;
      border-radius: 0.2rem;
      font-size: 0.14rem;
      font-weight: 400;
      line-height: 0.2rem;
      min-width: 1.09rem;
      outline: none;
    }
    .graybtn {
      border: 1px solid rgba(96, 96, 96, 1);
      color: #424242;
      background: none;
    }
    .redbtn {
      border: 1px solid #fc0324;
      background: #fc0324;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/agreement.vue